import { Touchpoint } from "../services/types/touchpoint.type";
import { getFullName } from "./common";

export const formatTouchpoint = (
  touchpoint: Touchpoint,
  patientId: number | undefined
) => {
  return {
    ...touchpoint,
    patient: {
      ...touchpoint.patient,
      id: patientId || touchpoint.patient.id,
      fullName: getFullName({
        firstName: touchpoint?.patient?.first_name ?? "",
        middleName: touchpoint?.patient?.middle_name || "",
        preferredName: touchpoint?.patient?.preferred_name || "",
        lastName: touchpoint?.patient?.last_name ?? "",
        title: touchpoint?.patient?.title,
        suffix: touchpoint?.patient?.suffix,
      }),
    },
    assigned_to: touchpoint?.assigned_to
      ? {
          ...touchpoint.assigned_to,
          fullName: getFullName({
            firstName: touchpoint?.assigned_to?.first_name ?? "",
            lastName: touchpoint?.assigned_to?.last_name ?? "",
            title: touchpoint?.assigned_to?.title,
          }),
        }
      : null,
    created_by: touchpoint?.created_by
      ? {
          ...touchpoint.created_by,
          fullName: getFullName({
            firstName: touchpoint?.created_by?.first_name ?? "",
            lastName: touchpoint?.created_by?.last_name ?? "",
            title: touchpoint?.created_by?.title,
          }),
        }
      : null,
  } as Touchpoint;
};
